import { ref, computed } from 'vue'
import { Message } from 'view-design'
import { clone } from '@/common/js/just.js'
import { BUDGET_MODE, AMEME_TYPE, ANCHOR_RELATED_TYPE } from '../../consts/index'

import { appendMaterialImageList } from '@/views/create/bytedance/hooks/useToutiaoPlansPreview.js'
import { fillBatchParams } from '@/views/create/bytedance/hooks/utils/fillBatchParams.js'
export const getDefaultCheckStates = () => {
  return {
    projectBudgetCheck: false, // 项目预算勾选
    projectTargetCheck: false, // 定向勾选
    adBudgetCheck: false, // 广告预算预算勾选
    bidCheck: false, // 出价勾选
    landingPageCheck: false, // 落地页勾选
    creativeCheck: false,
    descriptionCheck: false,
    anchorRelatedTypeCheck: false // 原生锚点
  }
}
export const getDefaultModalStates = () => {
  return {
    showGlobalBudgetModify: false,
    showGlobalTargetModify: false,
    showGlobalAdBudgetModify: false,
    showGlobalAdBidModify: false,
    showGlobalLandingPageModify: false,
    showGlobalCreativeModify: false,
    showGlobalDescriptionModify: false,
    showGlobalAnchorRelatedTypeModify: false
  }
}

const globalModal = ref(getDefaultModalStates())
const tableHeaderForm = ref(getDefaultCheckStates())
const currentModifyTableRow = ref(null)

export const useTableStates = (tableData, tableForm, emits) => {
  function onGlobalCheckChange(isCheckAll, prop) {
    const newData = tableData.value.map((row) => {
      return { ...row, [prop]: isCheckAll }
    })

    emits('update-table-data', newData)
  }

  function onTableRowCheckChange() {
    const isAllCheck = tableData.value.every((row) => {
      return row.isCheck
    })

    emits('update-table-form', {
      ...tableForm.value,
      isCheckAll: isAllCheck
    })
  }

  function onPreviewTableSelectionChange(selection) {
    console.log('selection output: ', selection)
  }
  return {
    globalModal,
    tableHeaderForm,
    currentModifyTableRow,
    onGlobalCheckChange,
    onTableRowCheckChange,
    onPreviewTableSelectionChange
  }
}

/**
 * @description: 修改项目预算
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useBudget = (tableData, emits, onModifyModalCancel) => {
  function onBudgetModify(rowIndex) {
    const hasRowIndex = !Object.is(Number(rowIndex), NaN)
    if (!hasRowIndex) {
      if (!tableData.value.some((row) => row.projectBudgetCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    const planNames = hasRowIndex ? [tableData.value[rowIndex].campaign_params.project_name] : tableData.value.filter(row => row.projectBudgetCheck).map(row => row.campaign_params.project_name)
    const newData = tableData.value.map((row) => {
      if (planNames.includes(row.campaign_params.project_name)) {
        return { ...row, projectBudgetCheck: true }
      }
      return row
    })
    emits('update-table-data', newData)

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalBudgetModify = true
  }

  function onProjectBudgetModifyConfirm(delivery_setting) {
    const { budget, budget_mode } = delivery_setting
    if (budget) {
      const newData = tableData.value.map((row) => {
        if (row.projectBudgetCheck) {
          const newRow = { ...row }
          newRow.outer_plan_params.delivery_setting.budget = budget_mode === BUDGET_MODE.DAY ? budget : 0
          newRow.outer_plan_params.delivery_setting.budget_mode = budget_mode
          return newRow
        }
        return row
      })
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onBudgetModify,
    onProjectBudgetModifyConfirm
  }
}

/**
 * @description: 修改定向
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useTargeting = (tableData, emits, onModifyModalCancel) => {
  function onTargetModify(rowIndex) {
    const hasRowIndex = !Object.is(Number(rowIndex), NaN)
    if (!hasRowIndex) {
      if (!tableData.value.some((row) => row.projectTargetCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    const planNames = hasRowIndex ? [tableData.value[rowIndex].campaign_params.project_name] : tableData.value.filter(row => row.projectTargetCheck).map(row => row.campaign_params.project_name)
    const newData = tableData.value.map((row) => {
      if (planNames.includes(row.campaign_params.project_name)) {
        return { ...row, projectTargetCheck: true }
      }
      return row
    })
    emits('update-table-data', newData)

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalTargetModify = true
  }

  function onTargetModifyConfirm(targeting) {
    if (targeting) {
      const newData = tableData.value.map((row) => {
        if (row.projectTargetCheck) {
          const newRow = { ...row, targetings: targeting }
          return newRow
        }
        return row
      })

      console.log('newDatanewData output: ', newData)
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onTargetModify,
    onTargetModifyConfirm
  }
}

/**
 * @description: 修改广告预算
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useAdBudget = (tableData, emits, onModifyModalCancel) => {
  function onAdBudgetModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        if (rowIndex === index) {
          return { ...row, adBudgetCheck: true }
        }
        return row
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.adBudgetCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalAdBudgetModify = true
  }

  function onAdBudgetModifyConfirm(budget) {
    if (budget) {
      const newData = tableData.value.map((row) => {
        if (row.adBudgetCheck) {
          const newRow = { ...row }
          newRow.creative_params.budget = budget
          return newRow
        }
        return row
      })
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onAdBudgetModify,
    onAdBudgetModifyConfirm
  }
}

/**
 * @description: 修改广告出价
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useAdBid = (tableData, emits, onModifyModalCancel) => {
  function onAdBidModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        if (rowIndex === index) {
          return { ...row, bidCheck: true }
        }
        return row
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.bidCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalAdBidModify = true
  }

  function onAdBidModifyConfirm(creative_params) {
    if (Object.keys(creative_params).length) {
      const newData = tableData.value.map((row) => {
        if (row.bidCheck) {
          const newRow = { ...row, creative_params }
          return newRow
        }
        return row
      })
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onAdBidModify,
    onAdBidModifyConfirm
  }
}

/**
 * @description: 修改落地页
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useAdLandingPage = (tableData, emits, onModifyModalCancel) => {
  function onAdLandingPageModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        if (rowIndex === index) {
          return { ...row, landingPageCheck: true }
        }
        return row
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.landingPageCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalLandingPageModify = true
  }

  function onAdLandingPageModifyConfirm(vals) {
    if (vals?.length) {
      const [val] = vals
      const newData = tableData.value.map((row) => {
        if (row.landingPageCheck) {
          const newRow = { ...row, creative_params: { ...row.creative_params, web_url_pack_name: val.packName, web_url_material_list: val.contents || [] } }
          return newRow
        }
        return row
      })
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onAdLandingPageModify,
    onAdLandingPageModifyConfirm
  }
}
/**
 * @description: 修改创意组
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useCreative = (tableData, emits, onModifyModalCancel) => {
  function onCreativeModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        if (rowIndex === index) {
          return { ...row, creativeCheck: true }
        }
        return row
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.creativeCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalCreativeModify = true
  }

  function onCreativeModifyConfirm(creativeItem) {
    const newData = tableData.value.map((row) => {
      if (row.creativeCheck) {
        const planRow = appendMaterialImageList(row, creativeItem)
        // const { creative_params } = fillBatchParams(planRow, row.plan, creativeItem)
        const newRow = { ...row, creative_params: planRow.creative_params }
        return newRow
      }
      return row
    })
    emits('update-table-data', newData)
    onModifyModalCancel()
  }

  return {
    onCreativeModify,
    onCreativeModifyConfirm
  }
}

/**
 * @description: 修改文案包
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useDescription = (tableData, emits, onModifyModalCancel) => {
  function onDescriptionModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        return { ...row, descriptionCheck: rowIndex === index }
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.descriptionCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    globalModal.value.showGlobalDescriptionModify = true
  }
  function onDescriptionModifyConfirm(descs) {
    if (descs?.length) {
      const [desc] = descs
      const content = desc.content.slice(0, 10)
      const newData = tableData.value.map((row) => {
        if (row.descriptionCheck) {
          const newRow = {
            ...row,
            creative_params: {
              ...row.creative_params,
              title_pack_name: desc.packName,
              title_material_list: content.map((item) => ({ title: item }))
            }
          }
          return newRow
        }
        return row
      })
      emits('update-table-data', newData)
      onModifyModalCancel()
    }
  }

  return {
    onDescriptionModify,
    onDescriptionModifyConfirm
  }
}

/**
 * @description: 修改原生锚点
 * @param {*} tableData
 * @param {*} emits
 * @return {*}
 */
export const useAnchorRelatedType = (tableData, emits, onModifyModalCancel) => {
  const adAnchorRelatedTypeVisible = computed(() => {
    const [row] = tableData.value
    const { anchor_related_type } = row.creative_params.native_setting || {}
    return anchor_related_type === ANCHOR_RELATED_TYPE.SELECT
  })

  function onAnchorRelatedTypeModify(rowIndex) {
    if (!Object.is(Number(rowIndex), NaN)) {
      const newData = tableData.value.map((row, index) => {
        if (rowIndex === index) {
          return { ...row, anchorRelatedTypeCheck: true }
        }
        return row
      })
      emits('update-table-data', newData)
    } else {
      if (!tableData.value.some((row) => row.anchorRelatedTypeCheck)) {
        return Message.warning('请选择修改行')
      }
    }

    // 保存当前需要更改的行，如果是全选更改，那么保存第一个
    const row = tableData.value[rowIndex || 0]
    currentModifyTableRow.value = clone(row)
    globalModal.value.showGlobalAnchorRelatedTypeModify = true
  }

  function onAnchorRelatedTypeModifyConfirm(selectedAnchor) {
    const { anchor_name, anchor_type, anchor_id } = selectedAnchor || {}
    if (!anchor_name) return Message.warning('请选择锚点')
    const newData = tableData.value.map((row) => {
      if (row.anchorRelatedTypeCheck) {
        const newRow = {
          ...row,
          creative_params: {
            ...row.creative_params,
            anchor_name,
            anchor_material_list: [
              {
                anchor_type,
                anchor_id
              }
            ]
          }
        }
        return newRow
      }
      return row
    })
    emits('update-table-data', newData)
    onModifyModalCancel()
  }

  return {
    adAnchorRelatedTypeVisible,
    onAnchorRelatedTypeModify,
    onAnchorRelatedTypeModifyConfirm
  }
}
